import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpointsV2';
import { BrushstrokePanel } from '@/components/layout/BrushstrokePanel';

export const smallPanelHeight = '28.34px';

export interface BrushstrokeDividerProps {
  colour?: string;
  direction?: string;
}

const BrushstrokeDivider = ({
  colour = 'deep-blue',
  direction = 'up',
}: BrushstrokeDividerProps) => {
  return (
    <Container colour={colour} imageOrientation={direction}>
      <BrushstrokePanel />
    </Container>
  );
};

const Container = styled.div<{
  imageOrientation?: string;
  colour?: string;
}>`
  width: 100%;
  overflow: hidden;
  transform: ${({ imageOrientation }) =>
    imageOrientation === 'up' ? 'rotate(0deg)' : 'rotate(180deg)'};
  position: relative;
  top: ${({ imageOrientation }) =>
    imageOrientation === 'up' ? '1px' : '-1px'};
  padding: var(--spacing-200) 0 0 0;

  ${screen.md} {
    padding: var(--spacing-300) 0 0 0;
  }
  svg {
    margin-bottom: -1px;
    height: auto;
    width: 100%;
    min-width: 1536px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
  path {
    fill: ${({ colour }) => `var(--colour-${colour})`};
  }
`;

export { BrushstrokeDivider };
